import WorkLogService from "../services/WorkLogService";
import { ReportExtension } from "./ReportExtension";

export const WorklogReportExport: Record<
  string,
  (project: string, month: number, year: number, userExternalId?: string, unified?: boolean) => Promise<any>
> = {
  PDF_WEEKLY_HOURS: (project, month, year) =>
    WorkLogService.downloadWeeklyHoursReport(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),
  PDF_DAILY_REPORT: (project, month, year) =>
    WorkLogService.downloadDetailedDailyReport(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),
  XLSX_WEEKLY_HOURS: (project, month, year) =>
    WorkLogService.downloadWeeklyHoursReportXLSX(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),
  XLSX_DAILY_REPORT: (project, month, year) =>
    WorkLogService.downloadDetailedDailyReportXLSX(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),
  PDF_VACATION_REPORT: (project, month, year) =>
    WorkLogService.downloadVacationReport(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),
  XLSX_VACATION_REPORT: (project, month, year) =>
    WorkLogService.downloadVacationReportXLSX(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),
  XLSX_MULTIMONTH_REPORT: (project, month, year) =>
    WorkLogService.downloadMultimonthReportXLSX(project, month, year).catch((err) => {
      return Promise.reject(err);
    }),

  PDF_REPORT_WORKLOG: (project, month, year, userExternalId, unified) =>
    WorkLogService.downloadReportWorkLog(project, month, year, unified, ReportExtension.PDF, userExternalId),
  XLSX_REPORT_WORKLOG: (project, month, year, userExternalId, unified) =>
    WorkLogService.downloadReportWorkLog(project, month, year, unified, ReportExtension.XLSX, userExternalId).catch((err) => {
      return Promise.reject(err);
    }),
};

export const WorklogReportExportExtension: Record<string, string> = {
  PDF_WEEKLY_HOURS: ".pdf",
  PDF_DAILY_REPORT: ".pdf",
  XLSX_WEEKLY_HOURS: ".xlsx",
  XLSX_DAILY_REPORT: ".xlsx",
  PDF_REPORT_WORKLOG: ".pdf",
  XLSX_REPORT_WORKLOG: ".xlsx",
  PDF_VACATION_REPORT: ".pdf",
  XLSX_VACATION_REPORT: ".xlsx",
  XLSX_MULTIMONTH_REPORT: ".xlsx",
};
